<div class="myModal p-3">
    <div class="d-flex">
        <h4 class="p-2"> {{title}}</h4>
        <mat-icon class="ml-auto" (click)="submitModal('false',modalFormErrors)">close</mat-icon>
    </div>
    <hr class="hr mb-4 mt-0" />
    <div #modalFormErrors >
        <app-form-errors [stepid]="'modal'" [linkForRouter]="linkForRouter"></app-form-errors>
        <hr class="hr mb-4 mt-4" *ngIf="hasError()" />
    </div>
    <div name="content">
        <div *ngFor="let field of fields">
            <app-form-input [prefixId]="'modal'" [parentForm]="tempForm" [modalOpen] = "modalOpen"
            [field]="concatField(field)"
            [repeatablePath]="field.repeatablePath"
            [modalValue]="modalValue"
                            [isRawValue]="isRawValue"
                            [repeatablePathWithIndex]="field.repeatablePath"
                            [getRepeatablePathWithIndexForInput]="getRepeatablePathWithIndexForInput"
            >
            </app-form-input>
            </div>
    </div>

    <div class="d-flex">
        <button class="btn btn-outline-primary mr-auto" (click)="submitModal('false',modalFormErrors)">Annuler</button>
        <button class="btn btn-outline-primary" (click)="submitModal('add',modalFormErrors)">Valider et ajouter une autre ligne de données</button>
        <button class="btn btn-outline-primary" (click)="submitModal('true',modalFormErrors)">Valider</button>
    </div>


</div>
